"use client";

import React from "react";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import { Accordion, AccordionItem } from "politicamente-informados-ds";


interface IAttrs {
  theme: "dark" | "light" | "simple";
  anchor?: string | undefined;
  title?: string | undefined;
  className?: string | undefined;
  style?: Record<string, unknown>;
};
export type IBlockAccordion = {
  attrs: IAttrs;
  innerBlocks: BlocksProps[];
};

export default function BlockAccordion({
  attrs,
  innerBlocks,
}: { attrs: Record<string, any>, innerBlocks: BlocksProps[] }) {

  const at = attrs as IAttrs;

  return (
    <Accordion theme={at.theme}>
      {!!innerBlocks?.length &&
        innerBlocks.map((item: BlocksProps, index: number) => {
          const at = item;
          return (
            <AccordionItem
              key={`accordion-item${index}`}
              title={at?.attrs?.title as string}
              active={at?.attrs?.defaultOpen as boolean}
              theme={at?.attrs?.theme as "dark" | "light" | "simple"}>
              {!!item?.innerBlocks?.length &&
                item?.innerBlocks?.map((block: BlocksProps, index: number) => {
                  return displayBlock(block, index);
                })}
            </AccordionItem>
          );
        })}
    </Accordion>
  );
}
